import { Modal } from '../../../utils/Modal';
import type { Dashboard } from '../../../../types/dashboard';
import { getPersonData } from '@/components/utils/CorgeeHelper';
import CapacityTracker from '../../CapacityTracker/CapacityTracker';

interface ConfigSPModalProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  dashboard?: Dashboard;
}

export const ConfigCapacityTracker: React.FC<any> = ({
  open,
  setOpen,
  dashboard,
}: ConfigSPModalProps) =>
{
  const config: any =
    open && dashboard
      ? {
        canEdit: getPersonData().canEdit,
        canDelete: getPersonData().canDelete,
        canTemporary: getPersonData().canTemporary,
        dashboardId: String(dashboard.DashboardId),
        projectId: Number(dashboard.ProjectId),
        dashboard: dashboard,
      }
      : {};
  return (
    <Modal open={open} onClose={() => setOpen(false)} title="Capacity Tracker" preventCloseClickOut>
      <div className="max-w-[1080px] flex-col max-h-full z-[200] bg-white dark:bg-[#2d2f2f] overflow-hidden ">
        <CapacityTracker
          config={config}
          openConfig={true}
          handleCloseModal={() => setOpen(false)}
          registerSaveFn={() => {}}
        />
      </div>
    </Modal>
  );
};
